import { apiClient } from "@/lib/apiClient";
import type { ProductStockDto, ProductStockStateDto } from "@/types/stock.types";

export const PRODUCT_STOCKS_KEY = "product-stocks/";

export const listProductStocks = async (): Promise<ProductStockDto[]> => {
  const stocks = await apiClient.get<ProductStockDto[]>(PRODUCT_STOCKS_KEY);
  return Array.isArray(stocks) ? stocks : [];
};

export const getProductStock = (id: string): Promise<ProductStockStateDto> =>
  apiClient.get<ProductStockStateDto>(`product-stocks/${id}`);
